import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { ReactComponent as ApptrackSubmit } from 'assets/icons/apptrackSubmit.svg';
import { Modal, TextAreaField, Label, DatePicker } from 'components';
import {
  isInvestor,
  outcomes,
  isRejectedStatus,
  isSubmitter,
  isObjectionCommittee,
} from 'utils';
import { radioOptions, radioOptionsBeneficiaryObjection } from './utils';
import { rejectAudit, updateFormField } from 'store/forms/actions';
import { Radio } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { useLocation } from 'react-router-dom';
import SuccessModal from '../successModal';

const SubmitModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  submitDisabled,
  formKey,
  outcome,
  businessKey,
}) => {
  const dispatch = useDispatch();
  const localisation = useLocation();
  const carrier = useSelector(state => state.forms?.carrier);
  const rejectKtpReason = useSelector(
    state => state.forms?.carrier?.rejectKtpReason
  );
  const rejectKtpMessage = useSelector(
    state => state.forms?.carrier?.rejectKtpMessage
  );
  const user = useSelector(state => state.user);
  const isBeneficiary =
    user?.groups?.filter(a => a.id.startsWith('Beneficiary')).length > 0;
  const isUserKTP =
    user?.groups?.filter(a => a.id.startsWith('KTP')).length > 0;
  const isUserProvider =
    user?.groups?.filter(a => a.id.startsWith('ProviderResourceGroup')).length >
    0;
  const provider = useSelector(state => state.forms?.provider);
  const taskName = useSelector(state => state.forms.task.taskName);
  const rejectKtp = outcome === outcomes.rejectKtp;
  const approveBeneficiary = outcome === outcomes.approveBeneficiary;
  const rejectBeneficiary = outcome === outcomes.rejectBeneficiary;
  const rejectAudit = outcome === outcomes.rejectAudit;
  const returnObjection = outcome === outcomes.returnObjection;
  const [successModalVisible ,setSuccessVisible] = useState(false);
  console.log("successModalVisible",successModalVisible);

  const disabled =
    (rejectKtp &&
      (!rejectKtpReason ||
        (rejectKtpReason?.includes('Άλλος Λόγος') &&
          isEmpty(carrier?.rejectKtpMessage)))) ||
    ((rejectBeneficiary || rejectAudit) &&
      (!carrier?.rejectBeneficiaryReason ||
        (carrier?.rejectBeneficiaryReason?.includes('Άλλος Λόγος') &&
          isEmpty(carrier?.rejectBeneficiaryMessage)))) ||
    (returnObjection &&
      isEmpty(carrier?.providerReturnDate));

  const renderContent = () => {
    if (isBeneficiary) {
      if (taskName === 'task.name.submit_application') {
        return (
          <div>
            <ApptrackSubmit></ApptrackSubmit>
            <div className="submit-text mb-2 mt-1">
              Υποβολή στο CoE
            </div>
            Πρόκειται να υποβάλετε την Αίτηση Επενδυτικού Σχεδίου στο Center of Excellence.
            <br/>Μπορείτε να υποβάλλετε μόνο μία αίτηση ανά επενδυτικό σχέδιο.
            <p className='mt-2'>Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. </p>
          </div>
        );
      } else {
          return (
            <div>
              <ApptrackSubmit></ApptrackSubmit>
              <div className="content-title-2">
                Υποβολή Αίτησης
              </div>
              Πρόκειται να υποβάλετε την Αίτηση Επενδυτικού Σχεδίου στο TAA.
              <br></br>
              Μπορείτε να υποβάλλετε μόνο μία αίτηση ανά επενδυτικό σχέδιο.
              <br></br>
              <br/>
              Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. 
            </div>
          );
        }
    }
  };

  const submit = () => {
    // setSuccessVisible(true);
    if (window.location?.pathname.includes('viewform')) {
      setSuccessVisible(true);
      setIsVisible(false);
    } else {
      setIsVisible(false);
      handleSubmit();
    }
  };

  return (
    <>
      <Modal
        isVisible={isVisible}
        handleCancel={() => {
          setIsVisible(false);
          if (outcome === outcomes.rejectKtp) {
            dispatch(
              updateFormField({
                group: 'carrier',
                key: 'rejectKtpReason',
                value: null,
              })
            );
            dispatch(
              updateFormField({
                group: 'carrier',
                key: 'rejectKtpMessage',
                value: null,
              })
            );
          }
          if (outcome === outcomes.rejectBeneficiary || outcome === outcomes.rejectAudit) {
            dispatch(
              updateFormField({
                group: 'carrier',
                key: 'rejectBeneficiaryReason',
                value: null,
              })
            );
            dispatch(
              updateFormField({
                group: 'carrier',
                key: 'rejectBeneficiaryMessage',
                value: null,
              })
            );
          }
          if (outcome === outcomes.returnObjection) {
            dispatch(
              updateFormField({
                group: 'carrier',
                key: 'providerReturnDate',
                value: null,
              })
            );
            dispatch(
              updateFormField({
                group: 'carrier',
                key: 'providerReturnComments',
                value: "",
              })
            );
          }
        }}
        handleConfirm={submit}
        width={
          [outcomes.rejectKtp, outcomes.rejectBeneficiary, outcomes.rejectAudit].includes(outcome)
            ? 700
            : 400
        }
        cancelText={(isUserKTP || rejectBeneficiary  || rejectAudit) ? 'Επιστροφή' : 'Ακύρωση'}
        okText={
          [
            outcomes.rejectKtp,
            outcomes.approveKtp,
            outcomes.rejectBeneficiary,
            outcomes.approveBeneficiary,
            outcomes.rejectAudit,
            outcomes.approveAudit,
            outcomes.returnObjection,
          ].includes(outcome)
            ? 'Επιβεβαίωση'
            : isBeneficiary
            ? 'Επιβεβαίωση'
            : 'Επιβεβαίωση'
        }
        submitDisabled={disabled}
        formKey={formKey}
        Icon={outcome === outcomes.rejectKtp ? WarningRed : WarningBlue}
        outcome={outcome}
        user={user}
      >
        <div className="modal-submit-content">{renderContent()}</div>
      </Modal>
      <SuccessModal isVisible={successModalVisible} setVisible={setSuccessVisible}></SuccessModal>
    </>
  );
};

export default SubmitModal;
